import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unset',
  standalone: false,
})
export class UnsetPipe implements PipeTransform {
  transform<T>(value: T): string | T {
    return value === null ? 'nicht gesetzt' : value;
  }
}
